import logoFacebook from 'components/images/logos/logo_facebook.svg';
import useFacebookSetup from './useFacebookSetup';
import ChannelCard from "../../Utilities/ChannelCard";

export default function FacebookProvider() {
	const { initiateFacebookSetup } = useFacebookSetup()
	return (
		<ChannelCard
			icon={logoFacebook}
			label={'Facebook'}
			description={'Get social support and moderation on your Facebook Ads, Mentions, Posts, Reviews, and DMs'}
			onClick={initiateFacebookSetup}
		/>
	)
}